import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import "pages/style.css";
import { Link } from 'react-router-dom';

moment.locale('ru')

export function AllEvents() {
    const [events, setEvents] = useState([])
    const url = "/api/get/allevents"
    let history = useHistory();
    

    useEffect(() => {
        let unmounted = false;
        async function getE() {
            const resp = await axios.post(url);
            const responce =  resp.data
            if (!unmounted) {
                setEvents(responce);
            }
        }
        getE();
        return () => {
            unmounted = true;
        };
    }, []);

    const drawTable = () => {
        return ( 
            <div>
                <table className='.aevents'>
                <tbody>
                    <tr>
                        <th className='thead'>Объект контроля</th>
                        <th className='thead'>Дата</th>
                        <th className='thead'>Вид мероприятия</th>
                        <th className='thead'>Подвид мероприятия</th>
                        <th className='thead'>Инспектор</th>
                        <th>Действия</th>
                    </tr>
                    {events.map((key) => (
                            <tr>
                                {console.log(key.id)}
                                <td>{key.value}</td>
                                <td>{moment(key.date).format('LL')}</td>
                                <td>{key.typename}</td>
                                <td>{key.subtypename.String}</td>
                                <td>{key.inspector}</td>
                            <td><Link to={{
                                pathname: `/edit/event`,
                                state: { reqevent: key }}}><button>Редактировать</button></Link></td>
                            </tr>  
                    ))}
                </tbody>
            </table>
        </div>
)
                    }
    
    
    return(
        <div className='main'>
                          
             {drawTable(events)}
            <br /> <br />
            <input type={"button"} value={"Назад"} onClick={history.goBack} />
        </div>
    )
}